var exports = {
  "k": "x61f99309--ea1bf8--container",
  "T": "x61f99309--ea1bf8--hints-container",
};

module.exports = exports;
